//--- React ---
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
//--- Components ---
import ButtonGoback from "../../../components/button/buttonGoback";
import StationGeneral from "../../../components/station/view/genaral";
import StationFiles from "../../../components/station/view/files";
import StationGalary from "../../../components/station/view/galary";
import ParameterWarnings from "../../../components/station/view/parameterWarnings";
import StationCamera from "../../../components/station/view/camera";
//--- Models ---
import { StationFullData } from "../../../models/types/station";

//--- Services ---
import stationSvc from "../../../services/api/station";

//--- Utils ---
import Loading from "../../../components/loading/loading";
import { notify } from "../../../common/notificationService";
import { UrlCollection } from "../../../common/url-collection";
import { useResponsive } from "../../../hooks/mediaQuery";

const ViewStationPage = () => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<StationFullData | null>(null);
    const { id } = useParams<{ id?: string }>();
    const { isXs } = useResponsive();

    useEffect(() => {
        if (id) {
            getStationById(id);
        }
    }, [id]);

    const getStationById = async (id: string) => {
        setLoading(true);
        try {
            const res = await stationSvc.getStationfullData(id);
            setData(res.content);
        } catch (e: any) {
            notify("Lỗi", "Xảy ra lỗi", "danger");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="page-wrapper list flex flex-col">

            <ButtonGoback />
            {loading ? <Loading /> : (
                <div>
                    {data && (
                        <div className="bg-white rounded-md mt-3 py-2">
                            <div className={isXs ? "px-2 py-1" : "px-4 py-2"}>
                                <StationGeneral data={data!} defaultOpen editUrl={UrlCollection.EditStation.replace(":id", id!)} />
                            </div>
                            <div className={isXs ? "px-2 py-1" : "px-4 py-2"}>
                                <StationGalary data={data!.images || []} editUrl={UrlCollection.EditStation.replace(":id", id!)} />
                            </div>
                            <div className={isXs ? "px-2 py-1" : "px-4 py-2"}>
                                <StationFiles data={data!.attachments || []} editUrl={UrlCollection.EditStation.replace(":id", id!)} />
                            </div>
                            <div className={isXs ? "px-2 py-1" : "px-4 py-2"}>
                                <ParameterWarnings data={data!.parameterWarnings || []} editUrl={UrlCollection.EditStation.replace(":id", id! + "?tab=parameterWarnings")} />
                            </div>
                            <div className={isXs ? "px-2 py-1" : "px-4 py-2"}>
                                <StationCamera data={data!.cameras || []} editUrl={UrlCollection.EditStation.replace(":id", id! + "?tab=camera")} />
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default ViewStationPage;